import React from 'react';

import { Container, StyledCircularProgress } from './Spinner.styled';

const Spinner = () => (
  <Container data-testid="spinner-div">
    <StyledCircularProgress />
  </Container>
);

export default Spinner;
